import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getStudentiForBilling(uname, token) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getStudentiForBilling.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          // JSON.parse già gestisce correttamente l'unescape di virgolette e caratteri speciali
          const resp = JSON.parse(body.toString());
          resolve(resp);
        } catch (error) {
          console.error("[getStudentiForBilling] Errore parsing JSON:", error);
          console.error(
            "[getStudentiForBilling] Risposta ricevuta:",
            body.toString().substring(0, 500)
          );
          reject(error);
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
    });

    req.write(postData);

    req.end();
  });
}
